import { combineReducers } from '@reduxjs/toolkit';
import get from 'lodash/get';

import type { OrgProfile } from '@appTypes/esb';
import { SET_ORGANIZATION } from '@shared/duck/actions';
import { resetOnLogoutReducer } from '@utils';

import {
  UNIT_INFO_ERROR,
  UNIT_INFO_REQUEST,
  UNIT_INFO_RESPONSE,
  UNIT_PROFILE_ERROR,
  UNIT_PROFILE_REQUEST,
  UNIT_PROFILE_RESPONSE,
} from './actions';

const unitInfo = (
  state: OrgProfile | Record<string, never> = {},
  { type, payload }: { type: string; payload: OrgProfile },
) => {
  switch (type) {
    case UNIT_INFO_REQUEST:
    case UNIT_INFO_ERROR:
    case SET_ORGANIZATION: {
      return {};
    }
    case UNIT_INFO_RESPONSE: {
      return payload;
    }
    default: {
      return state;
    }
  }
};

const unitInfoLoading = (state = false, { type }: { type: string }) => {
  switch (type) {
    case UNIT_INFO_REQUEST: {
      return true;
    }
    case UNIT_INFO_RESPONSE:
    case UNIT_INFO_ERROR: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const unitInfoError = (
  state: boolean | null = null,
  { type }: { type: string },
) => {
  switch (type) {
    case UNIT_INFO_REQUEST:
    case UNIT_INFO_RESPONSE: {
      return null;
    }
    case UNIT_INFO_ERROR: {
      return true;
    }
    default: {
      return state;
    }
  }
};

const unitProfiles = (
  state: Record<string, OrgProfile> = {},
  { type, payload }: { type: string; payload: OrgProfile },
) => {
  switch (type) {
    case UNIT_PROFILE_REQUEST:
    case UNIT_PROFILE_ERROR:
      return state;
    case UNIT_PROFILE_RESPONSE: {
      const orgGuid = get(payload, ['organizationGuid']);
      return { ...state, [orgGuid]: payload };
    }

    default: {
      return state;
    }
  }
};

const reducer = combineReducers({
  unitInfo,
  unitProfiles,
  unitInfoLoading,
  unitInfoError,
});

export default resetOnLogoutReducer(reducer);
